import { render, staticRenderFns } from "./CompilationFolders.vue?vue&type=template&id=13396fd6&scoped=true"
import script from "./CompilationFolders.vue?vue&type=script&lang=js"
export * from "./CompilationFolders.vue?vue&type=script&lang=js"
import style0 from "./CompilationFolders.vue?vue&type=style&index=0&id=13396fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13396fd6",
  null
  
)

export default component.exports